import { Box, Typography } from "@mui/material";
import { BilletGroup } from "../../../models";
import { AxiomHeatStatusChip, HeatCommentIcon } from "../../shared";

interface BilletItemProps {
  group: BilletGroup;
  isSearchMatch: boolean;
  isFirst: boolean;
  isLast: boolean;
}

export const BilletItem = ({
  group,
  isSearchMatch,
  isFirst,
  isLast,
}: BilletItemProps) => {
  return (
    <Box
      key={`${group.BilletsGroupID}-${group.Position}`}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1px",
        minHeight: "26px",
        padding: "3px 6px",
        borderTop: isFirst
          ? (theme) => `1px solid ${theme.palette.grey[200]}`
          : "none",
        borderRadius: isLast ? "0 0 3px 3px" : "0",
        backgroundColor: isSearchMatch ? "#468BE6" : "transparent",
      }}
    >
      {/* Heat Number + Count (like "JO5093 2") */}
      <Box
        sx={{
          fontSize: "14px",
          lineHeight: "1.2",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: "1 1 0%",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {group.AxiomHeatStatus ? (
            <Box
              sx={{
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
              }}
            >
              <AxiomHeatStatusChip status={group.AxiomHeatStatus} />
            </Box>
          ) : null}
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                color: (theme) => theme.palette.grey[700],
              }}
            >
              {group.HeatNumber}
            </Typography>
            {group.Comments ? (
              <Box
                sx={{
                  position: "absolute",
                  left: "100%",
                  top: 0,
                  bottom: 0,
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: "4px",
                }}
              >
                <HeatCommentIcon
                  comment={group.Comments}
                  heatName={group.HeatNumber}
                />
              </Box>
            ) : null}
          </Box>
        </Box>
        <Typography
          component="span"
          sx={{
            fontSize: "12px",
            color: (theme) => theme.palette.grey[600],
            fontWeight: 500,
            minWidth: "20px",
            textAlign: "right",
          }}
        >
          {group.BilletsCount}
        </Typography>
      </Box>
    </Box>
  );
};

BilletItem.displayName = "BilletItem";
